var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../../../action/au.action';
import { MessageService } from '../../../../service/message.service';
import { PageService } from '../../../../models/page.service';
import { ContentBaseComponent } from '../../../../component/base/contentbase.component';
import { ContentBaseService } from '../../../../component/base/contentbase.service';
var KtsProgressComponent = /** @class */ (function (_super) {
    __extends(KtsProgressComponent, _super);
    function KtsProgressComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        // 初期は表示しない
        _this.belongs = 0;
        _this.progressMode = null;
        _this.areaSectionTitle = '';
        _this.items = [];
        _this.areaCount = [];
        _this.step = [];
        _this.showSummaryButton = true;
        _this.summaryOnsite = new SummaryOnsite();
        _this.summaryConstruction = new SummaryConstruction();
        _this.summaryStandard = new SummaryStandard();
        _this.taskSummary = [];
        return _this;
    }
    KtsProgressComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        // this.progressMode = jsonpath.value(this.component, '$.params.progressMode') || ProgressMode.project;
        // this.getType();
    };
    // getType(): void {
    //     this.service.getType('CONSTRUCTION_STEP').subscribe(rec => {
    //         this.step = rec;
    //         this.items = [];
    //         for (let s of this.step) {
    //             this.items.push(new ProgressData());
    //         }
    //     });
    // }
    KtsProgressComponent.prototype.setUnsubscribe = function () {
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    KtsProgressComponent.prototype.onSubscribe = function (data) {
        if (typeof data.id !== 'undefined') {
            this.id = data.id;
        }
        // 所属
        this.belongs = data.belongs;
        // 展開／個別区分
        this.progressMode = data.mode;
        if (data.mode === 'project') {
            this.areaSectionTitle = 'エリア合計';
        }
        if (data.mode === 'general') {
            this.areaSectionTitle = '全体';
        }
        // 現調
        if (data.summary_onsite != null) {
            this.summaryOnsite = data.summary_onsite;
            // 完了率
            this.summaryOnsite.complete_rate = this.getCompleteRate((this.summaryOnsite.complete_on_schedule + this.summaryOnsite.complete_delay), this.summaryOnsite.total);
        }
        else {
            this.summaryOnsite = new SummaryOnsite();
        }
        // 工事
        if (data.summary_construction != null) {
            this.summaryConstruction = data.summary_construction;
            // 完了率
            this.summaryConstruction.complete_rate = this.getCompleteRate((this.summaryConstruction.complete_on_schedule + this.summaryConstruction.complete_delay), this.summaryConstruction.total);
        }
        else {
            this.summaryConstruction = new SummaryConstruction();
        }
        // 現調・工事以外
        if (data.summary_standard != null) {
            this.summaryStandard = data.summary_standard;
            // 完了率
            this.summaryStandard.complete_rate = this.getCompleteRate((this.summaryStandard.complete_on_schedule + this.summaryStandard.complete_delay), this.summaryStandard.total);
        }
        else {
            this.summaryStandard = new SummaryStandard();
        }
        // 展開工事
        if (this.progressMode === "project" /* project */ || this.progressMode === "construction" /* construction */) {
            // タスク合計
            var taskSummary = new TaskSummary();
            taskSummary.store_name = '全体';
            taskSummary.complete =
                this.summaryStandard.complete_on_schedule
                    + this.summaryStandard.complete_delay
                    + this.summaryOnsite.complete_on_schedule
                    + this.summaryOnsite.complete_delay
                    + this.summaryConstruction.complete_on_schedule
                    + this.summaryConstruction.complete_delay;
            taskSummary.total =
                this.summaryStandard.total
                    + this.summaryOnsite.total
                    + this.summaryConstruction.total;
            taskSummary.remnant = taskSummary.total - taskSummary.complete;
            // 完了率
            taskSummary.complete_rate = this.getCompleteRate(taskSummary.complete, taskSummary.total);
            this.taskSummary.push(taskSummary);
        }
        // 一般工事
        if (this.progressMode === "general" /* general */) {
            if (data.general_construction_store_count != null) {
                this.taskSummary = data.general_construction_store_count;
                for (var _i = 0, _a = this.taskSummary; _i < _a.length; _i++) {
                    var taskSummary = _a[_i];
                    taskSummary.complete_rate = this.getCompleteRate(taskSummary.complete, taskSummary.total);
                }
            }
        }
        // 全体（エリア別）
        // 個別工事の場合はレスポンス無し
        if (data.area_count != null) {
            this.areaCount = data.area_count;
            for (var _b = 0, _c = this.areaCount; _b < _c.length; _b++) {
                var area = _c[_b];
                area.complete_rate = this.getCompleteRate(area.complete, area.total);
            }
        }
    };
    KtsProgressComponent.prototype.getCompleteRate = function (complete, total) {
        if (complete == 0) {
            return 0;
        }
        return Math.floor((complete / total) * 100);
    };
    KtsProgressComponent.prototype.onEventSubscribe = function (e) {
        var _this = this;
        // 進捗状況表示ボタン
        if (e === this.componentName + '#progress#summary') {
            if (typeof this.id !== 'undefined' && this.id != null) {
                var url = '/v1/gen/project-m-progress-api';
                if (this.progressMode === "construction" /* construction */) {
                    url = '/v1/gen/construction-m-progress-api';
                }
                this.service.setBaseUrl(url);
                this.service.postRecord({ id: this.id }).subscribe(function (rec) {
                    _this.areaCount = rec.area_count;
                    if (rec.project_summary_standard != null) {
                        _this.summaryStandard = rec.project_summary_standard;
                    }
                    _this.showSummaryButton = false;
                });
            }
        }
    };
    KtsProgressComponent.prototype.onEvent = function (e1, e2, rec) {
        if (e2 === 'openModalStandardUnscheduled'
            || e2 === 'openModalStandardDelay'
            || e2 === 'openModalStandardUndef'
            || e2 === 'openModalOnsiteProgressDelay'
            || e2 === 'openModalOnsiteRemnantUnscheduled'
            || e2 === 'openModalOnsiteRemnantDelay'
            || e2 === 'openModalOnsiteReschedule'
            || e2 === 'openModalOnsiteUndef'
            || e2 === 'openModalConstructionProgressDelay'
            || e2 === 'openModalConstructionRemnantUnscheduled'
            || e2 === 'openModalConstructionRemnantDelay'
            || e2 === 'openModalConstructionReschedule'
            || e2 === 'openModalConstructionUndef'
            || e2 === 'openModalRemnantStore') {
            // 残拠点数
            if (e2 === 'openModalRemnantStore') {
                // 全体の場合はエリアの絞り込みは不要
                if (rec.area !== '全体') {
                    this.action.setRec({ 'area': rec.area });
                }
            }
            this.action.firstAction(e2);
        }
        else {
        }
    };
    KtsProgressComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-progress',
                    template: "<p class=\"sectionHeading\">\u73FE\u8ABF\u30FB\u5DE5\u4E8B\u30BF\u30B9\u30AF</p>\n<div class=\"tableWrapper\">\n  <table class=\"tableWrapper_table\" id=\"{{ componentName }}+'1'\">\n    <thead>\n    <tr>\n      <th></th>\n      <th colspan=\"2\">\u5B8C\u4E86\u6570</th>\n      <th colspan=\"2\">\u4ED5\u639B\u304B\u308A\u6570</th>\n      <th colspan=\"3\">\u6B8B\u6570</th>\n      <th rowspan=\"2\" class=\"v-middle\">\u30EA\u30B9\u30B1</th>\n      <th rowspan=\"2\" class=\"v-middle\">\u5BFE\u5FDC\u4E0D\u8981</th>\n      <th rowspan=\"2\" class=\"v-middle\">\u5C0F\u8A08</th>\n      <th rowspan=\"2\" class=\"v-middle\">\u5B8C\u4E86\u7387</th>\n    </tr>\n    <tr>\n      <th></th>\n      <th>\u4E88\u5B9A\u901A\u308A</th>\n      <th>\u4E88\u5B9A\u8D85\u904E</th>\n      <th>\u4E88\u5B9A\u901A\u308A</th>\n      <th>\u4E88\u5B9A\u8D85\u904E</th>\n      <th>\u672A\u5B9A</th>\n      <th>\u671F\u65E5\u524D</th>\n      <th>\u4E88\u5B9A\u8D85\u904E</th>\n    </tr>\n    </thead>\n    <tbody>\n    <tr>\n      <td>\u73FE\u8ABF\u30BF\u30B9\u30AF</td>\n      <td class=\"-txtalnright\">{{ summaryOnsite.complete_on_schedule}}</td>\n      <td class=\"-txtalnright\">{{ summaryOnsite.complete_delay}}</td>\n      <td class=\"-txtalnright\">{{ summaryOnsite.progress_on_schedule}}</td>\n      <td class=\"-txtalnright -underline\"><a href=\"javascript:void(0);\" (click)=\"onEvent($event, 'openModalOnsiteProgressDelay', {})\">{{ summaryOnsite.progress_delay}}</a></td>\n      <td class=\"-txtalnright -underline\"><a href=\"javascript:void(0);\" (click)=\"onEvent($event, 'openModalOnsiteRemnantUnscheduled', {})\">{{ summaryOnsite.remnant_unscheduled}}</a></td>\n      <td class=\"-txtalnright\">{{ summaryOnsite.remnant_before}}</td>\n      <td class=\"-txtalnright -underline\"><a href=\"javascript:void(0);\" (click)=\"onEvent($event, 'openModalOnsiteRemnantDelay', {})\">{{ summaryOnsite.remnant_delay}}</a></td>\n      <td class=\"-txtalnright -underline\"><a href=\"javascript:void(0);\" (click)=\"onEvent($event, 'openModalOnsiteReschedule', {})\">{{ summaryOnsite.reschedule}}</a></td>\n      <td class=\"-txtalnright\">{{ summaryOnsite.non_necessity}}</td>\n      <td class=\"-txtalnright\">{{ summaryOnsite.total}}</td>\n      <td class=\"-txtalnright\">{{ summaryOnsite.complete_rate}}%</td>\n    </tr>\n    <tr>\n      <td>\u5DE5\u4E8B\u30BF\u30B9\u30AF</td>\n      <td class=\"-txtalnright\">{{ summaryConstruction.complete_on_schedule}}</td>\n      <td class=\"-txtalnright\">{{ summaryConstruction.complete_delay}}</td>\n      <td class=\"-txtalnright\">{{ summaryConstruction.progress_on_schedule}}</td>\n      <td class=\"-txtalnright -underline\"><a href=\"javascript:void(0);\" (click)=\"onEvent($event, 'openModalConstructionProgressDelay', {})\">{{ summaryConstruction.progress_delay}}</a></td>\n      <td class=\"-txtalnright -underline\"><a href=\"javascript:void(0);\" (click)=\"onEvent($event, 'openModalConstructionRemnantUnscheduled', {})\">{{ summaryConstruction.remnant_unscheduled}}</a></td>\n      <td class=\"-txtalnright\">{{ summaryConstruction.remnant_before}}</td>\n      <td class=\"-txtalnright -underline\"><a href=\"javascript:void(0);\" (click)=\"onEvent($event, 'openModalConstructionRemnantDelay', {})\">{{ summaryConstruction.remnant_delay}}</a></td>\n      <td class=\"-txtalnright -underline\"><a href=\"javascript:void(0);\" (click)=\"onEvent($event, 'openModalConstructionReschedule', {})\">{{ summaryConstruction.reschedule}}</a></td>\n      <td class=\"-txtalnright\">{{ summaryConstruction.non_necessity}}</td>\n      <td class=\"-txtalnright\">{{ summaryConstruction.total}}</td>\n      <td class=\"-txtalnright\">{{ summaryConstruction.complete_rate}}%</td>\n    </tr>\n    </tbody>\n  </table>\n  <span *ngIf=\"belongs==1\">\n  <div class=\"-comment\" *ngIf=\"summaryOnsite.undef > 0\">\u203B\u73FE\u8ABF\u30BF\u30B9\u30AF\u306B\u4E0D\u660E\u30C7\u30FC\u30BF\u304C{{summaryOnsite.undef}}\u4EF6\u3042\u308A\u307E\u3059\u3002\n    <span class=\"-underline\"><a href=\"javascript:void(0);\" (click)=\"onEvent($event, 'openModalOnsiteUndef', {})\">\u3053\u3061\u3089</a></span>\u304B\u3089\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002\n  </div>\n  <div class=\"-comment\" *ngIf=\"summaryConstruction.undef > 0\">\u203B\u5DE5\u4E8B\u30BF\u30B9\u30AF\u306B\u4E0D\u660E\u30C7\u30FC\u30BF\u304C{{summaryConstruction.undef}}\u4EF6\u3042\u308A\u307E\u3059\u3002\n    <span class=\"-underline\"><a href=\"javascript:void(0);\" (click)=\"onEvent($event, 'openModalConstructionUndef', {})\">\u3053\u3061\u3089</a></span>\u304B\u3089\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002\n  </div>\n  </span>\n</div>\n\n<span *ngIf=\"belongs==1\">\n  <p class=\"sectionHeading -mt-2\">\u73FE\u8ABF\u30FB\u5DE5\u4E8B\u4EE5\u5916\u306E\u30BF\u30B9\u30AF</p>\n  <div class=\"tableWrapper\">\n    <table class=\"tableWrapper_table\" id=\"{{ componentName }}+'2'\">\n      <thead>\n      <tr>\n        <th></th>\n        <th colspan=\"2\">\u5B8C\u4E86\u6570</th>\n        <th colspan=\"3\">\u6B8B\u6570</th>\n        <th rowspan=\"2\" class=\"v-middle\">\u5BFE\u5FDC\u4E0D\u8981</th>\n        <th rowspan=\"2\" class=\"v-middle\">\u5C0F\u8A08</th>\n        <th rowspan=\"2\" class=\"v-middle\">\u5B8C\u4E86\u7387</th>\n      </tr>\n      <tr>\n        <th></th>\n        <th>\u4E88\u5B9A\u901A\u308A</th>\n        <th>\u4E88\u5B9A\u8D85\u904E</th>\n        <th>\u672A\u5B9A</th>\n        <th>\u671F\u65E5\u524D</th>\n        <th>\u4E88\u5B9A\u8D85\u904E</th>\n      </tr>\n      </thead>\n      <tbody>\n      <tr>\n        <td>\u73FE\u8ABF\u30FB\u5DE5\u4E8B\u4EE5\u5916\u306E\u30BF\u30B9\u30AF</td>\n        <td class=\"-txtalnright\">{{ summaryStandard.complete_on_schedule}}</td>\n        <td class=\"-txtalnright\">{{ summaryStandard.complete_delay}}</td>\n        <td class=\"-txtalnright -underline\"><a href=\"javascript:void(0);\" (click)=\"onEvent($event, 'openModalStandardUnscheduled', {})\">{{ summaryStandard.remnant_unscheduled}}</a></td>\n        <td class=\"-txtalnright\">{{ summaryStandard.remnant_before}}</td>\n        <td class=\"-txtalnright -underline\"><a href=\"javascript:void(0);\" (click)=\"onEvent($event, 'openModalStandardDelay', {})\">{{ summaryStandard.remnant_delay}}</a></td>\n        <td class=\"-txtalnright\">{{ summaryStandard.non_necessity}}</td>\n        <td class=\"-txtalnright\">{{ summaryStandard.total}}</td>\n        <td class=\"-txtalnright\">{{ summaryStandard.complete_rate}}%</td>\n      </tr>\n      </tbody>\n    </table>\n    <span *ngIf=\"belongs==1\">\n    <div class=\"-comment\" *ngIf=\"summaryStandard.undef > 0\">\u203B\u73FE\u8ABF\u30FB\u5DE5\u4E8B\u4EE5\u5916\u306E\u30BF\u30B9\u30AF\u306B\u4E0D\u660E\u30C7\u30FC\u30BF\u304C{{summaryStandard.undef}}\u4EF6\u3042\u308A\u307E\u3059\u3002\n      <span class=\"-underline\"><a href=\"javascript:void(0);\" (click)=\"onEvent($event, 'openModalStandardUndef', {})\">\u3053\u3061\u3089</a></span>\u304B\u3089\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002\n    </div>\n    </span>\n  </div>\n\n  <p class=\"sectionHeading -mt-2\">\u30BF\u30B9\u30AF\u5408\u8A08</p>\n  <div class=\"tableWrapper\">\n    <table class=\"tableWrapper_table\" id=\"{{ componentName }}+'3'\">\n      <thead>\n      <tr>\n        <th></th>\n        <th>\u5B8C\u4E86\u6570</th>\n        <th>\u6B8B\u6570</th>\n        <th>\u7DCF\u30BF\u30B9\u30AF\u6570</th>\n        <th>\u5B8C\u4E86\u7387</th>\n      </tr>\n      </thead>\n      <tbody>\n      <tr *ngFor=\"let task of taskSummary;\">\n        <td>{{task.store_name}}</td>\n        <td class=\"-txtalnright\">{{ task.complete }}</td>\n        <td class=\"-txtalnright\">{{ task.remnant }}</td>\n        <td class=\"-txtalnright\">{{ task.total }}</td>\n        <td class=\"-txtalnright\">{{ task.complete_rate }}%</td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</span>\n\n<span *ngIf=\"progressMode=='project' || progressMode=='general'\">\n  <p class=\"sectionHeading -mt-2\">{{areaSectionTitle}}</p>\n  <div class=\"tableWrapper\">\n    <table class=\"tableWrapper_table\" id=\"{{ componentName }}+'4'\">\n      <thead>\n      <tr>\n        <th></th>\n        <th>\u5B8C\u4E86\u62E0\u70B9\u6570</th>\n        <th>\u6B8B\u62E0\u70B9\u6570</th>\n        <th>\u4E2D\u65AD</th>\n        <th>\u4E2D\u6B62</th>\n        <th>\u7DCF\u62E0\u70B9\u6570</th>\n        <th>\u5B8C\u4E86\u7387</th>\n      </tr>\n      </thead>\n      <tbody>\n      <tr *ngFor=\"let area of areaCount;\">\n        <td>{{area.area}}</td>\n        <td class=\"-txtalnright\">{{area.complete}}</td>\n        <td class=\"-txtalnright -underline\"><a href=\"javascript:void(0);\" (click)=\"onEvent($event, 'openModalRemnantStore', {'area':area.area})\">{{area.remnant}}</a></td>\n        <td class=\"-txtalnright\">{{area.interruption}}</td>\n        <td class=\"-txtalnright\">{{area.cancel}}</td>\n        <td class=\"-txtalnright\">{{area.total}}</td>\n        <td class=\"-txtalnright\">{{area.complete_rate}}%</td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</span>\n\n<div class=\"-mb-2\"></div>\n",
                    styles: [".tableWrapper_table tbody tr {\n  cursor: auto;\n}\n\n.tableWrapper_table tbody tr:hover {\n  background: none;\n}\n\n.tableWrapper_table th {\n  font-weight: bold;\n  font-size: 1.5rem;\n  color: #808080;\n  padding: 6px 10px;\n  text-align: center;\n  border: 1px solid rgba(0, 0, 0, 0.07);\n  white-space: nowrap;\n}\n\n.tableWrapper_table td {\n  font-size: 1.3rem;\n  padding: 6px 10px;\n  text-align: left;\n  border: 1px solid rgba(0, 0, 0, 0.07);\n  white-space: nowrap;\n}\n\n.v-middle {\n  vertical-align: middle;\n}\n\n.-red {\n  color: red !important;\n}\n"]
                }] }
    ];
    /** @nocollapse */
    KtsProgressComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ContentBaseService }
    ]; };
    return KtsProgressComponent;
}(ContentBaseComponent));
export { KtsProgressComponent };
var ProgressData = /** @class */ (function () {
    function ProgressData() {
        this.complete = 0;
        this.task = 0;
        this.rate = 0;
        this.delay = 0;
        this.current = false;
    }
    return ProgressData;
}());
export { ProgressData };
var SummaryStandard = /** @class */ (function () {
    function SummaryStandard() {
        this.complete_on_schedule = 0;
        this.complete_delay = 0;
        this.remnant_unscheduled = 0;
        this.remnant_before = 0;
        this.remnant_delay = 0;
        this.non_necessity = 0;
        this.undef = 0;
        this.total = 0;
        this.complete_rate = 0;
    }
    return SummaryStandard;
}());
export { SummaryStandard };
var SummaryOnsite = /** @class */ (function () {
    function SummaryOnsite() {
        this.complete_on_schedule = 0;
        this.complete_delay = 0;
        this.progress_on_schedule = 0;
        this.progress_delay = 0;
        this.remnant_unscheduled = 0;
        this.remnant_before = 0;
        this.remnant_delay = 0;
        this.reschedule = 0;
        this.non_necessity = 0;
        this.undef = 0;
        this.total = 0;
        this.complete_rate = 0;
    }
    return SummaryOnsite;
}());
export { SummaryOnsite };
var SummaryConstruction = /** @class */ (function () {
    function SummaryConstruction() {
        this.complete_on_schedule = 0;
        this.complete_delay = 0;
        this.progress_on_schedule = 0;
        this.progress_delay = 0;
        this.remnant_unscheduled = 0;
        this.remnant_before = 0;
        this.remnant_delay = 0;
        this.reschedule = 0;
        this.non_necessity = 0;
        this.undef = 0;
        this.total = 0;
        this.complete_rate = 0;
    }
    return SummaryConstruction;
}());
export { SummaryConstruction };
var TaskSummary = /** @class */ (function () {
    function TaskSummary() {
        this.store_name = '';
        this.complete = 0;
        this.remnant = 0;
        this.total = 0;
        this.complete_rate = 0;
    }
    return TaskSummary;
}());
export { TaskSummary };
var AreaCount = /** @class */ (function () {
    function AreaCount() {
        this.complete = 0;
        this.remnant = 0;
        this.interruption = 0;
        this.cancel = 0;
        this.total = 0;
        this.complete_rate = 0;
    }
    return AreaCount;
}());
export { AreaCount };
//# sourceMappingURL=progress.component.js.map